import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=8454d3a2"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports